"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var type_of_1 = require("type-of");
// Common
exports.reduce = function (r, def) { return function (arr) { return arr.reduce(r, def); }; };
exports.as = function (obj, f) { return f(obj); };
exports.prop = function (prop) { return function (obj) { return obj[prop]; }; };
exports.tuple = {
    first: function (t) { return t[0]; },
    second: function (t) { return t[1]; },
};
exports.makeAsync = function (f) { return function (getT) { return getT.then(f); }; };
exports.syncOrAsync = function (f) {
    return function (obj) {
        return (typeof obj.then !== 'undefined'
            ? obj.then(f)
            : f(obj));
    };
};
// Array functions
exports.at = function (index) { return function (arr) { return arr[index]; }; };
exports.chunk = function (size) { return function (arr) {
    if (size <= 0) {
        console.error("Chunk expects a size greater than zero");
        return [arr];
    }
    var temp = [];
    for (var i = 0, j = arr.length; i < j; i += size) {
        temp.push(arr.slice(i, i + size));
    }
    return temp;
}; };
exports.concat = function (item) { return function (arr) { return [].concat(arr).concat(item); }; };
exports.concatReduce = function (acc, item) { return exports.concat(item)(acc); };
exports.createIndex = function (getId, transform) { return function (arr) { return arr.reduce(function (acc, cur) {
    var _a;
    return (__assign({}, acc, (_a = {}, _a[getId(cur)] = transform(cur), _a)));
}, {}); }; };
exports.diff = function (arr1, arr2) { return exports.unique(arr1).filter(function (obj) { return !arr2.includes(obj); }); };
exports.entries = function (arr) { return arr.entries(); };
exports.every = function (f) { return function (arr) { return arr.every(f); }; };
exports.filter = function (f) { return function (arr) { return arr.filter(f); }; };
exports.find = function (f) { return function (arr) { return arr.find(f); }; };
exports.findIndex = function (f) { return function (arr) { return arr.findIndex(f); }; };
exports.first = function (arr) { return exports.at(0)(arr); };
exports.flatten = function (arr) { return exports.reduce(function (acc, cur) { return [].concat(acc).concat(cur); }, [])(arr); };
exports.from = exports.concat([]);
exports.includes = function (item) { return function (arr) { return arr.includes(item); }; };
exports.indexOf = function (item, start) { return function (arr) { return arr.indexOf(item, start); }; };
exports.intersection = function (arr1, arr2) { return exports.unique(arr1).filter(function (obj) { return arr2.includes(obj); }); };
exports.joinWith = function (sep) { return function (arr) { return arr.join(sep); }; };
exports.juxt = function () {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    return function (obj) { return funcs.map(function (f) { return f(obj); }); };
};
exports.keys = function (arr) { return arr.keys(); };
exports.last = function (arr) { return exports.at(arr.length - 1)(arr); };
exports.lastIndexOf = function (item) { return function (arr) { return arr.lastIndexOf(item); }; };
exports.map = function (m) { return function (arr) { return arr.map(m); }; };
exports.partition = function (getId) { return function (arr) { return arr.reduce(function (acc, cur) { return exports.as(getId(cur), function (key) {
    var _a;
    return (__assign({}, acc, (_a = {}, _a[getId(cur)] = acc[key] ? exports.concat(cur)(acc[key]) : [cur], _a)));
}); }, {}); }; };
exports.partitionOn = function (propName) { return exports.partition(exports.prop(propName)); };
exports.pop = function (arr) {
    var a = exports.concat([])(arr);
    var elem = a.pop();
    return [elem, a];
};
exports.push = function (item) { return function (arr) {
    var a = exports.concat([])(arr);
    a.push(item);
    return a;
}; };
exports.range = function (start, end) {
    return __spread(Array(Math.abs(end - start) + 1).keys()).map(function (_, i) { return start < end ? i + start : start - i; });
};
exports.reverse = function (arr) { return [].concat(arr).reverse(); };
exports.shift = function (arr) {
    var a = exports.concat([])(arr);
    var elem = a.shift();
    return [elem, a];
};
exports.unshift = function (item) { return function (arr) {
    var a = exports.concat([])(arr);
    a.unshift(item);
    return a;
}; };
exports.slice = function (start, end) { return function (arr) { return arr.slice(start, end); }; };
exports.splice = function (start, length) { return function (arr) {
    var newArr = __spread(arr);
    newArr.splice(start, length);
    return newArr;
}; };
exports.some = function (f) { return function (arr) { return arr.some(f); }; };
var sortInt = function (f) { return function (arr) { return exports.concat([])(arr).sort(f); }; };
sortInt.asNumber = {
    asc: function (a, b) { return a - b; },
    desc: function (a, b) { return b - a; },
};
sortInt.asText = {
    asc: function (a, b) { return a.localeCompare(b); },
    desc: function (a, b) { return b.localeCompare(a); },
};
sortInt.by = function (f) { return ({
    asc: function (a, b) {
        var aVal = f(a);
        var bVal = f(b);
        return typeof aVal === 'number' && typeof bVal === 'number' ? sortInt.asNumber.asc(aVal, bVal) :
            typeof aVal === 'string' && typeof bVal === 'string' ? sortInt.asText.asc(aVal, bVal) :
                sortInt.asText.asc("" + aVal, "" + bVal);
    },
    desc: function (a, b) {
        var aVal = f(a);
        var bVal = f(b);
        return typeof aVal === 'number' && typeof bVal === 'number' ? sortInt.asNumber.desc(aVal, bVal) :
            typeof aVal === 'string' && typeof bVal === 'string' ? sortInt.asText.desc(aVal, bVal) :
                sortInt.asText.desc("" + aVal, "" + bVal);
    },
}); };
exports.sort = sortInt;
exports.union = function (arr1, arr2) { return exports.unique(arr1.concat(arr2)); };
exports.unique = function (arr) { return __spread(new Set(arr)); };
// Object methods
exports.clone = function (obj) { return Object.assign({}, obj); };
exports.or = function (def) { return function (obj) { return obj ? obj : def; }; };
exports.pick = function () {
    var fields = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fields[_i] = arguments[_i];
    }
    return function (obj) {
        var ret = {};
        fields.forEach((function (key) {
            ret[key] = obj[key];
        }));
        return ret;
    };
};
exports.omit = function () {
    var fields = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fields[_i] = arguments[_i];
    }
    return function (obj) {
        var ret = __assign({}, obj);
        fields.forEach((function (key) {
            delete ret[key];
        }));
        return ret;
    };
};
exports.objMap = function (f) {
    return function (container) {
        return Object.keys(container).reduce(function (obj, id) {
            var _a;
            return (__assign({}, obj, (_a = {}, _a[id] = f(container[id], id), _a)));
        }, {});
    };
};
// String functions
exports.append = function (suffix) { return function (str) { return "" + str + suffix; }; };
exports.charAt = function (index) { return function (str) { return str.charAt(index); }; };
exports.charCodeAt = function (index) { return function (str) { return str.charCodeAt(index); }; };
exports.endsWith = function (suffix) { return function (str) { return str.endsWith(suffix); }; };
exports.hash = function (str) { return JSON.stringify(str); };
exports.matches = function (regex) { return function (str) { return str.match(regex); }; };
exports.prepend = function (prefix) { return function (str) { return "" + prefix + str; }; };
exports.repeat = function (count) { return function (str) { return str.repeat(count); }; };
exports.replace = function (search) { return function (replacement) { return function (str) { return str.replace(search, replacement); }; }; };
exports.search = function (term) { return function (str) { return str.search(term); }; };
exports.split = function (delim) { return function (str) { return str.split(delim); }; };
exports.startsWith = function (prefix) { return function (str) { return str.startsWith(prefix); }; };
exports.substr = function (start, len) { return function (str) { return str.substr(start, len); }; };
exports.toLowerCase = function (str) { return str.toLowerCase(); };
exports.toLocaleLowerCase = function (str) { return str.toLocaleLowerCase(); };
exports.toUpperCase = function (str) { return str.toUpperCase(); };
exports.toLocaleUpperCase = function (str) { return str.toLocaleUpperCase(); };
exports.trim = function (str) { return str.trim(); };
// checks
exports.isEmpty = function (obj) { return obj ? false : true; };
exports.isNotEmpty = function (obj) { return obj ? true : false; };
// Helpers
exports.debug = function (obj) { console.log(obj); return obj; };
exports.identity = function (obj) { return obj; };
exports.get = function (obj) { return function () { return obj; }; };
exports.stringify = function (obj) { return JSON.stringify(obj); };
exports.arg = function (index) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args[index];
}; };
exports.args = function () {
    var indices = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        indices[_i] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return indices.map(function (i) { return args[i]; });
    };
};
exports.switchOn = function (key, actions) { return (actions[key] || actions.default || (function () { return undefined; }))(); };
exports.typeSwitch = function (obj, actions) { return exports.switchOn(type_of_1.default(obj), actions); };
exports.matchOn = function (actions, defaultValue, disambiguator) { return function (str) {
    var multiMatchFixer = disambiguator || (function (matches) { return matches[0]; });
    var matches = actions.filter(function (action) { return exports.tuple.first(action).test("" + str); });
    return matches.length === 1 ? exports.tuple.second(matches[0])() :
        matches.length > 1 ? exports.tuple.second(multiMatchFixer(matches))() :
            defaultValue;
}; };
// Function composition
exports.compose = function () {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    return function (obj) { return funcs.reduceRight(function (acc, cur) { return cur(acc); }, obj); };
};
exports.pipe = function () {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    return function (obj) { return funcs.reduce(function (acc, cur) { return cur(acc); }, obj); };
};
// Other helpers
exports.memoize = function (f, options) {
    var keyGen = options && options.keyGen ? options.keyGen : exports.stringify;
    var queueInvalidation = options && options.queueInvalidation ? options.queueInvalidation : (function () { });
    var results = {};
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = keyGen(args);
        if (typeof results[key] === 'undefined') {
            results[key] = f.apply(void 0, __spread(args));
            queueInvalidation(function () { delete results[key]; }, key, results[key]);
        }
        return results[key];
    };
};
exports.memoizePromise = function (f, options) {
    var keyGen = options && options.keyGen ? options.keyGen : exports.stringify;
    var queueInvalidation = options && options.queueInvalidation ? options.queueInvalidation : (function () { });
    var getInvalidator = options && options.getInvalidator ? options.getInvalidator : (function () { });
    var results = {};
    var errors = {};
    var isSuccess = {};
    var isRunning = {};
    var resolvers = {};
    var rejecters = {};
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = keyGen(args);
        if (typeof results[key] === 'undefined' && typeof errors[key] === 'undefined') {
            var p = new Promise(function (resolve, reject) {
                if (!Array.isArray(resolvers[key])) {
                    resolvers[key] = [];
                }
                if (!Array.isArray(rejecters[key])) {
                    rejecters[key] = [];
                }
                resolvers[key].push(resolve);
                rejecters[key].push(reject);
            });
            if (!isRunning[key]) {
                isRunning[key] = true;
                var invalidate_1 = function () {
                    delete results[key];
                    delete errors[key];
                    delete isSuccess[key];
                };
                f.apply(void 0, __spread(args)).then(function (result) {
                    isRunning[key] = false;
                    results[key] = result;
                    isSuccess[key] = true;
                    queueInvalidation(invalidate_1, key, result, undefined);
                    getInvalidator(invalidate_1);
                    resolvers[key].forEach(function (r) { r(result); });
                    resolvers[key] = [];
                    rejecters[key] = [];
                }).catch(function (err) {
                    isRunning[key] = false;
                    errors[key] = err;
                    isSuccess[key] = false;
                    queueInvalidation(invalidate_1, key, undefined, err);
                    getInvalidator(invalidate_1);
                    rejecters[key].forEach(function (r) { r(err); });
                    resolvers[key] = [];
                    rejecters[key] = [];
                });
            }
            return p;
        }
        return isSuccess[key] ? Promise.resolve(results[key]) : Promise.reject(errors[key]);
    };
};
